<template>
  <div
    class="modal fade"
    id="sessions-truncate"
    v-if="this.$store.getters.settings.type == 'local'"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            id="sessions-truncate-close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-success">
              {{ $t("online.truncate.title") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form class="row g-4 mt-2" onsubmit="return false">
            <div class="col-12">
              <label class="form-label" for="end_date">{{
                $t("online.truncate.end_date")
              }}</label>
              <div class="input-group">
                <input
                  type="date"
                  v-model="truncate.end_date"
                  @change="validate"
                  class="form-control"
                />
                <i class="ti ti-date"></i>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="only">{{
                $t("online.truncate.only")
              }}</label>
              <select class="form-select" v-model="truncate.only">
                <option value="all">{{ $t("online.truncate.all") }}</option>
                <option value="accounts">{{
                  $t("online.truncate.accounts_only")
                }}</option>
                <option value="cards">{{
                  $t("online.truncate.cards_only")
                }}</option>
              </select>
            </div>
            <div class="col-12">
              <input
                type="checkbox"
                v-model="truncate.confirmation"
                class="form-check-input"
              />
              <label class="form-check-label ms-1" for="confirm">{{
                $t("online.truncate.confirm")
              }}</label>
            </div>
            <div class="col-12 text-sm text-warning">
              {{ $t("online.truncate.warining_this_will_take_long_time") }}
            </div>
            <div
              class="col-12 text-sm text-danger"
              v-if="truncate.only != 'accounts'"
            >
              {{ $t("online.truncate.warning_cards") }}
            </div>
            <div class="col-12 text-sm text-danger" v-if="errors.end_date">
              {{ errors.end_date }}
            </div>
            <div class="col-12 text-center mt-12">
              <button
                :disabled="!truncate.confirmation || !validated"
                class="btn btn-success me-2"
                type="button"
                @click="store"
              >
                <i class="ti ti-eraser"></i>
                {{ $t("online.truncate.truncate") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "SessionsTruncate",
  computed: {
    ...mapGetters(["settings"]),
  },
  data() {
    return {
      truncate: {
        end_date: null,
        confirmation: false,
        only: "accounts",
      },
      validated: false,
      errors: {
        end_date: null,
      },
    };
  },
  methods: {
    async store() {
      document.getElementById("sessions-truncate-close").click();
      const message = this.$t("online.truncate.sessions_cleared_successfully");
      const error_message = this.$t(
        "control.some_thing_went_wrong_please_try_again",
      );
      try {
        const response = await axios.post(`sessions/truncate`, this.truncate);
        if (response.status == 200) {
          this.$notify({
            text: message,
            type: "success",
          });
        }
      } catch (error) {
        console.log(error);

        this.$notify({
          text: error.response?.data?.message || error_message,
          type: "error",
        });
      }
      this.$emit("updated");
    },
    validate() {
      this.validated = true;
      this.errors.end_date = null;
      const oneMonthAgo = new Date();
      // Subtract exactly 1 month from the current date/time
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
      if (new Date(this.truncate.end_date) > oneMonthAgo) {
        this.validated = false;
        this.errors.end_date = this.$t(
          "online.truncate.before_must_be_at_least_1month",
        );
      }
    },
  },
};
</script>
